export const sizes = {
  secondaryNavbarHeight: '4rem',
};

export const colors = {
  paleBlue: '#e9f7f9',
  lightLinkBlue: '#00DFFC',
  linkBlue: '#00b4cc',
  lightGray: '#e9ecef',
  light: '#AAAAB2',
  borderGray: '#ddd',
  mediumGray: '#868e96',
  darkGray: '#343a40',
  lightBg: '#f1f1f1',
  veryLightBg: '#fbfbfb' /* almost imperceptible light */,
  textDefault: '#212529',
  mediumGreen: '#005F6B',
  darkGreen: '#00424B',
  selectedBg: '#00b4cc',
  text: '#606a6a',
  textRed: '#CC0000',
  alertBg: '#fff9e5',
  alertText: '#856404',
  alertBorder: '#d6c79a',
  dangerText: '#dc3545',
  blueGray: '#99b3b8',
  insGreen: 'rgba(0,255,0,0.125)',
  insGreenOpaque: '#E0FFE0',
  insGreenText: '#006400',
  delRed: 'rgba(255,0,0,0.125)',
  delRedOpaque: '#FFE0E0',
  delRedText: '#640000',
  decisionTopHat: '#14a4b8',
  midnightTeal: '#015f6b',
  midnightTealTransparent: '#015f6b1f',
};

// BOOTSTRAP
export const bootstrapzIndex = {
  dropdown: 1000,
  sticky: 1020,
  fixed: 1030,
  modalBackdrop: 1040,
  modal: 1050,
  popover: 1060,
  tooltip: 1070,
} as const;

export const loadingBarStyles = {
  zIndex: bootstrapzIndex.dropdown,
  backgroundColor: '#00c2db',
  height: '2px',
};
